import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

/** Package type as returned nested inside a bundle item. */
@Serializable()
export class BundleItemPackageType {
  @JsonProperty('id')
  id!: number

  @JsonProperty('nameEn')
  nameEn: string = ''

  @JsonProperty('nameTh')
  nameTh: string = ''
}

/** The component package of a bundle item, trimmed to what the UI renders. */
@Serializable()
export class BundleItemPackage {
  @JsonProperty('id')
  id!: number

  @JsonProperty('name')
  name: string = ''

  @JsonProperty('price')
  price: number = 0

  @JsonProperty('packageType')
  packageType?: BundleItemPackageType
}

@Serializable()
export class BundleItem {
  @JsonProperty('id')
  id!: number

  @JsonProperty('packageId')
  packageId!: number

  @JsonProperty('quantity')
  quantity: number = 1

  @JsonProperty('package')
  package?: BundleItemPackage

  /** price x quantity, computed client-side for the item row subtotal. */
  get lineTotal(): number {
    return (this.package?.price ?? 0) * this.quantity
  }
}

@Serializable()
export class BundleBranchSummary {
  @JsonProperty('id')
  id!: number

  @JsonProperty('name')
  name: string = ''
}

@Serializable()
export class BundleData extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('name')
  name!: string

  @JsonProperty('description')
  description?: string

  @JsonProperty('price')
  price: number = 0

  @JsonProperty('branchId')
  branchId!: number

  @JsonProperty('branch')
  branch?: BundleBranchSummary

  /** false = archived, mirroring Package.isActive. */
  @JsonProperty('isActive')
  isActive: boolean = false

  /** Derived server-side from sales count: 'Active' | 'Not in use'. */
  @JsonProperty('status')
  status: string = ''

  /** Number of BundleItem rows — drives the "N items" Amount cell. */
  @JsonProperty('itemCount')
  itemCount: number = 0

  /** Sum of (component price x quantity) — the undiscounted bundle value. */
  @JsonProperty('itemsValue')
  itemsValue: number = 0

  @JsonProperty('items')
  items?: BundleItem[]

  @JsonProperty('createdAt')
  createdAt?: string

  /** Discount vs the summed component value; 0 when the bundle costs more. */
  get savingAmount(): number {
    return Math.max(0, this.itemsValue - this.price)
  }

  get savingPercent(): number {
    if (!this.itemsValue) return 0
    return Math.round((this.savingAmount / this.itemsValue) * 100)
  }
}

export type BundleItemPayload = {
  packageId: number
  quantity: number
}

export type CreateBundlePayload = {
  name: string
  description?: string
  branchId: number
  price: number
  items: BundleItemPayload[]
}

export type UpdateBundlePayload = Partial<CreateBundlePayload> & {
  isActive?: boolean
}
